import styled from "styled-components";

const BlockImages = styled.div`
  box-sizing: border-box;
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;

  .react-photo-album--button {
    cursor: zoom-in;
  }

  .react-photo-album--image {
    object-fit: cover;
  }
`;

export { BlockImages };
